import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
// import { HttpStatus } from '@core/classes/http-status.class';

import * as Objects from '@core/objects';
import * as Search from '@app/models/search';

import * as Access from '@app/models/access';
import { VersionFeedback } from '@core/models/version-feedback';

export enum LibraryActionType {

	// EVENT CALLS
    Init = "[Library] first call",
    // InitVersionStatusAccess = "[Library] first call for versions status access",
    // InitSuccess = "[Library] first call SUCCESS",

    LoadFilters = "[Library] Obtain filters",

    LoadVersionsStatusAccess = "[Library] GET - Obtain all versions status access for user",
    LoadVersionsStatusAccessSuccess  = "[Library] GET - Obtain all versions status access for user SUCCESS",
    LoadVersionsStatusAccessError  = "[Library] GET - Obtain all versions status access for user ERROR",

    LoadFilterLabels = "[Library] GET - Obtain labels filters - GET",
    LoadFilterLabelsSuccess = "[Library] GET - Obtain labels filter SUCCESS",
    LoadFilterLabelsError = "[Library] GET - Obtain labels filter ERROR",

    LoadFilterStatus = "[Library] GET - Obtain status filters - GET",
    LoadFilterStatusSuccess = "[Library] GET - Obtain status filter SUCCESS",
    LoadFilterStatusError = "[Library] GET - Obtain status filter ERROR",

    PushSearchFilters = "[Library] Add filter (silence mode)",
    ApplySearchFilter = "[Library] Add filter",
    RemoveSearchFilter = "[Library] Remove filter",

    SetSearchTerm = "[Library] set search term",
    // UpdateSearchQuery = "[Library] update search query",
    // SetSearchQuery = "[Library] set search query",

    SetVersionStatus = "[Library] PUT - Set single version status",
    SetVersionStatusSuccess = "[Library] PUT - Set single version status SUCCESS",
    SetVersionStatusError = "[Library] PUT - Set single version status ERROR",

    UpdateQueryParams = "[Library] update search query params",
    SetQueryParams = "[Library] set search query params",

    LoadResults = "[Library] dispatch search / load results - GET",
    LoadResultsSuccess = "[Library] dispatch search / load results - GET SUCCESS",
    LoadResultsError = "[Library] dispatch search / load results - GET ERROR",

    LoadVersionFeedbacks = "[Library] dispatch load results versions feedbacks - GET",
    LoadVersionFeedbacksPreSuccess = "[Library] dispatch versions pre processed feedbacks - GET PRE SUCCESS",
    LoadVersionFeedbacksSuccess = "[Library] dispatch load results versions feedbacks - GET SUCCESS",
    LoadVersionEmptyFeedbacksSuccess = "[Library] dispatch when no feedbacks for the versions",
    LoadVersionFeedbacksError = "[Library] dispatch load results versions feedbacks - GET ERROR",
    ClearVersionFeedbacks = "[Library] dispatch clear the results versions feedbacks to be uprated",

    ReloadResults = "[Library] set page to 1 and reload results - GET",

    UpdateVersion = "[Library] dispatch search a version - GET",
    UpdateVersionFeedbacks = "[Library] dispatch update feedbacks of a version",

    Clear = "[Library] clear data"
}

// Load Available Events
export class Init implements Action {
    readonly type = LibraryActionType.Init;
    constructor(public params: Search.SearchQueryParams, public feedbackAccess: boolean) {}
}

// export class InitVersionStatusAccess implements Action {
//     readonly type = LibraryActionType.InitVersionStatusAccess;
//     constructor() {}
// }

export class LoadFilters implements Action {
    readonly type = LibraryActionType.LoadFilters;
    constructor() {}
}

export class LoadVersionsStatusAccess implements Action {
    readonly type = LibraryActionType.LoadVersionsStatusAccess;
    constructor() {}
}

export class LoadVersionsStatusAccessSuccess implements Action {
    readonly type = LibraryActionType.LoadVersionsStatusAccessSuccess;
    constructor(public statusAccess: Array<Access.AccessVersionStatus>) {}
}

export class LoadVersionsStatusAccessError implements Action {
    readonly type = LibraryActionType.LoadVersionsStatusAccessError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadFilterLabels implements Action {
    readonly type = LibraryActionType.LoadFilterLabels;
    constructor() {}
}

export class LoadFilterLabelsSuccess implements Action {
    readonly type = LibraryActionType.LoadFilterLabelsSuccess;
    constructor(public labels: Array<Objects.Label>) {}
}

export class LoadFilterLabelsError implements Action {
    readonly type = LibraryActionType.LoadFilterLabelsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadFilterStatus implements Action {
    readonly type = LibraryActionType.LoadFilterStatus;
    constructor() {}
}

export class LoadFilterStatusSuccess implements Action {
    readonly type = LibraryActionType.LoadFilterStatusSuccess;
    constructor(public status: Array<Objects.Status>) {}
}

export class LoadFilterStatusError implements Action {
    readonly type = LibraryActionType.LoadFilterStatusError;
    constructor(public error: HttpErrorResponse) {}
}

export class SetVersionStatus implements Action {
    readonly type = LibraryActionType.SetVersionStatus;
    constructor(public versionId, public status: Objects.Status) {}
}

export class SetVersionStatusSuccess implements Action {
    readonly type = LibraryActionType.SetVersionStatusSuccess;
    constructor(public version: Objects.Version) {}
}

export class SetVersionStatusError implements Action {
    readonly type = LibraryActionType.SetVersionStatusError;
    constructor(public error: HttpErrorResponse) {}
}

export class ApplySearchFilter implements Action {
    readonly type = LibraryActionType.ApplySearchFilter;
    constructor(public filter: Search.SearchAppliedFilter) {}
}

export class PushSearchFilters implements Action {
    readonly type = LibraryActionType.PushSearchFilters;
    constructor(public filters: Search.SearchAppliedFilter[]) {}
}

export class RemoveSearchFilter implements Action {
    readonly type = LibraryActionType.RemoveSearchFilter;
    constructor(public filter: Search.SearchAppliedFilter) {}
}

export class SetSearchTerm implements Action {
    readonly type = LibraryActionType.SetSearchTerm;
    constructor(public term: string) {}
}

// export class UpdateSearchQuery implements Action {
//     readonly type = LibraryActionType.UpdateSearchQuery;
//     constructor() {}
// }

// export class SetSearchQuery implements Action {
//     readonly type = LibraryActionType.SetSearchQuery;
//     constructor(public query: string) {}
// }

export class UpdateQueryParams implements Action {
    readonly type = LibraryActionType.UpdateQueryParams;
    constructor() {}
}

export class SetQueryParams implements Action {
    readonly type = LibraryActionType.SetQueryParams;
    constructor(public params: Search.SearchQueryParams) {}
}

export class LoadResults implements Action {
    readonly type = LibraryActionType.LoadResults;
    constructor() {}
}

export class LoadResultsSuccess implements Action {
    readonly type = LibraryActionType.LoadResultsSuccess;
    constructor(public versions: Array<Objects.Version>) {}
}


export class LoadResultsError implements Action {
    readonly type = LibraryActionType.LoadResultsError;
    constructor(public error:  HttpErrorResponse) {}
}

export class ReloadResults implements Action {
    readonly type = LibraryActionType.ReloadResults;
    constructor() {}
}

export class LoadVersionFeedbacks implements Action {
    readonly type = LibraryActionType.LoadVersionFeedbacks;
    constructor(public versions: Array<Objects.Version>) {}
}

export class LoadVersionFeedbacksPreSuccess implements Action {
    readonly type = LibraryActionType.LoadVersionFeedbacksPreSuccess;
    constructor(public feedbacks: Array<VersionFeedback>) {}
}

export class LoadVersionFeedbacksSuccess implements Action {
    readonly type = LibraryActionType.LoadVersionFeedbacksSuccess;
    constructor(public feedbacks: Array<VersionFeedback>) {}
}

// update oct-2023 <diego@twonas.com> we need the versions updated for when no feedback remains.
export class LoadVersionEmptyFeedbacksSuccess implements Action {
    readonly type = LibraryActionType.LoadVersionEmptyFeedbacksSuccess;
    constructor(public versions: Array<Objects.Version>) {}
}

export class LoadVersionFeedbacksError implements Action {
    readonly type = LibraryActionType.LoadVersionFeedbacksError;
    constructor(public error:  HttpErrorResponse) {}
}

export class ClearVersionFeedbacks implements Action {
    readonly type = LibraryActionType.ClearVersionFeedbacks;
    constructor() {}
}

export class UpdateVersion implements Action {
    readonly type = LibraryActionType.UpdateVersion;
    constructor(public versionId: number) {}
}

export class UpdateVersionFeedbacks implements Action {
    readonly type = LibraryActionType.UpdateVersionFeedbacks;
    constructor(public versionId: number) {}
}

// export class UpdateVersionError implements Action {
//     readonly type = LibraryActionType.UpdateVersionError;
//     constructor(public versionId, public error:  HttpErrorResponse) {}
// }

export class Clear implements Action {
    readonly type = LibraryActionType.Clear;
    constructor() {}
}

export type LibraryActions = 	Init |
                                // InitVersionStatusAccess |
                                LoadFilters |

                                LoadVersionsStatusAccess |
                                LoadVersionsStatusAccessSuccess |
                                LoadVersionsStatusAccessError |
                                
                                LoadFilterLabels |
                                LoadFilterLabelsSuccess |
                                LoadFilterLabelsError |

                                LoadFilterStatus |
                                LoadFilterStatusSuccess |
                                LoadFilterStatusError | 

                                SetVersionStatus |
                                SetVersionStatusSuccess |
                                SetVersionStatusError |
                                
                                PushSearchFilters |
                                ApplySearchFilter |
                                RemoveSearchFilter |

                                SetSearchTerm |
                                // UpdateSearchQuery |
                                // SetSearchQuery | 

                                UpdateQueryParams |
                                SetQueryParams |

                                LoadResults |
                                LoadResultsSuccess |
                                LoadResultsError |

                                LoadVersionFeedbacks |
                                LoadVersionFeedbacksPreSuccess |
                                LoadVersionFeedbacksSuccess |
                                LoadVersionEmptyFeedbacksSuccess |
                                LoadVersionFeedbacksError |
                                ClearVersionFeedbacks |

                                ReloadResults | 
                                
                                UpdateVersion |
                                UpdateVersionFeedbacks |
                                // UpdateVersionError |

                                Clear
                                ;
